import React from "react";
import Hero from "../components/Hero";
import TrustSection from "../components/TrustSection";
import ServicesGrid from "../components/ServicesGrid";
import TechmateFramework from "../components/TechmateFramework";
import IndustriesGrid from "../components/IndustriesGrid";
import CyberRiskCTA from "../components/CyberRiskCTA";
import AssessmentTimeline from "../components/AssessmentTimeline";
import ComplianceBadges from "../components/ComplianceBadges";
import TechPartners from "../components/TechPartners";
import OEMShowcase from "../components/OEMShowcase";
import ContactSection from "../components/ContactSection";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <TechPartners />
      <TrustSection />
      <ServicesGrid />
      <TechmateFramework />
      <CyberRiskCTA />
      <AssessmentTimeline />
      <OEMShowcase />
      <IndustriesGrid />
      <ComplianceBadges />
      <ContactSection />
    </div>
  );
}
